import { render, staticRenderFns } from "./FormPhoneNumberQuestion.vue?vue&type=template&id=3437f344"
import script from "./FormPhoneNumberQuestion.vue?vue&type=script&lang=js"
export * from "./FormPhoneNumberQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports